import { useState } from "react";

const LeftSideBare = () => {
  const [active, setActive] = useState(
    localStorage.getItem("Tab") != null
      ? localStorage.getItem("Tab")
      : "dashboard",
  );
  return (
    <>
      <aside className="fixed right-0 top-0 h-screen w-[280px] bg-deep-navy z-50 flex flex-col shadow-2xl border-l border-white/10">
        {/* Fixed Header / Branding */}
        <div className="h-16 shrink-0 px-6 flex items-center justify-between border-b border-white/10 bg-deep-navy/95 backdrop-blur-md">
          <div className="flex items-center gap-3 text-white">
            <div className="w-10 h-10 rounded-xl bg-vibrant-orange/15 border border-vibrant-orange/30 flex items-center justify-center text-vibrant-orange shadow-inner">
              <span className="material-symbols-outlined text-2xl">layers</span>
            </div>
            <div className="flex flex-col">
              <span className="font-headline-md text-lg leading-tight font-bold tracking-tight text-white">
                  نظام منافذ
              </span>
              <span className="text-[11px] text-white/50">
                بوابة ادارة المتاجر والجمعيات عبرالخرائط     
              </span>
            </div>
          </div>
        </div>
        {/* Scrollable Nav Container (Infinite items support with custom smooth scrollbar) */}
        <nav className="flex-1 overflow-y-auto custom-sidebar-scrollbar px-3 py-4 flex flex-col gap-5">
          {/* قسم الرئيسية */}
          <div className="flex flex-col gap-1">
            <div className="px-3 pb-1 text-[11px] font-semibold uppercase tracking-wider text-white/40">
              الرئيسية
            </div>
            <a
              data-path="dashboard"
              href="/admin/home"
              onClick={() => localStorage.setItem("Tab", "dashboard")}
              className={`flex items-center px-3.5 py-2.5 rounded-lg transition-all gap-3 text-sm ${
                active === "dashboard"
                  ? "bg-vibrant-orange text-white shadow-lg shadow-vibrant-orange/20 ring-1 ring-white/20 font-semibold"
                  : "text-white/75 hover:text-white hover:bg-white/5 group"
              }`}
            >
              <span className="material-symbols-outlined text-[20px] text-white/60 group-hover:text-vibrant-orange transition-colors">
                dashboard
              </span>
              <span className="font-label-md">لوحة التحكم</span>
            </a>
          </div>
          {/* قسم إدارة النظام */}
          <div className="flex flex-col gap-1">
            <div className="px-3 pb-1 text-[11px] font-semibold uppercase tracking-wider text-white/40">
              إدارة المتاجر والفروع
            </div>
              <a
              aria-current="page"
              data-path="users"
              onClick={() => localStorage.setItem("Tab", "listShops")}
              className={`flex items-center px-3.5 py-2.5 rounded-lg transition-all gap-3 text-sm ${
                active === "listShops"
                  ? "bg-vibrant-orange text-white shadow-lg shadow-vibrant-orange/20 ring-1 ring-white/20 font-semibold"
                  : "text-white/75 hover:text-white hover:bg-white/5 group"
              }`}
              href="/admin/listShops"
            >
              <span className="material-symbols-outlined text-[20px]">
                search
              </span>
              <span className="font-label-md"> 
                   قائمة المتاجر
              </span>
            </a>
              <a
              aria-current="page"
              data-path="users"
              onClick={() => localStorage.setItem("Tab", "filterBranches")}
              className={`flex items-center px-3.5 py-2.5 rounded-lg transition-all gap-3 text-sm ${
                active === "filterBranches"
                  ? "bg-vibrant-orange text-white shadow-lg shadow-vibrant-orange/20 ring-1 ring-white/20 font-semibold"
                  : "text-white/75 hover:text-white hover:bg-white/5 group"
              }`}
              href="/admin/filterBranches"
            >
              <span className="material-symbols-outlined text-[20px]">
                search
              </span>
              <span className="font-label-md"> 
                  البحث العام فرع المتاجر 
              </span>
            </a>
            <a
              aria-current="page"
              data-path="users"
              onClick={() => localStorage.setItem("Tab", "updateBranchesExll")}
              className={`flex items-center px-3.5 py-2.5 rounded-lg transition-all gap-3 text-sm ${
                active === "updateBranchesExll"
                  ? "bg-vibrant-orange text-white shadow-lg shadow-vibrant-orange/20 ring-1 ring-white/20 font-semibold"
                  : "text-white/75 hover:text-white hover:bg-white/5 group"
              }`}
              href="/admin/updateBranchesExll"
            >
              <span className="material-symbols-outlined text-[20px]">
                group
              </span>
              <span className="font-label-md"> 
                تحديث بيانات فروع المتاجر عبر اكسل
              </span>
            </a>
            <a
              data-path="roles"
              href="/admin/linkBranchesCategories"
              onClick={() =>
                localStorage.setItem("Tab", "linkBranchesCategories")
              }
              className={`flex items-center px-3.5 py-2.5 rounded-lg transition-all gap-3 text-sm ${
                active === "linkBranchesCategories"
                  ? "bg-vibrant-orange text-white shadow-lg shadow-vibrant-orange/20 ring-1 ring-white/20 font-semibold"
                  : "text-white/75 hover:text-white hover:bg-white/5 group"
              }`}
            >
              <span className="material-symbols-outlined text-[20px] text-white/60 group-hover:text-vibrant-orange transition-colors">
                admin_panel_settings
              </span>
              <span className="font-label-md"> ربط المتاجر بالخدمات </span>
            </a>
          </div>
          {/* قسم الخدمات والمتاجر */}
          <div className="flex flex-col gap-1">
            <div className="px-3 pb-1 text-[11px] font-semibold uppercase tracking-wider text-white/40">
              إدارة الجمعيات
            </div>
             <a
              data-path="store-services"
              href="/admin/filterOrgs"
              onClick={() => localStorage.setItem("Tab", "filterOrgs")}
              className={`flex items-center px-3.5 py-2.5 rounded-lg transition-all gap-3 text-sm ${
                active === "filterOrgs"
                  ? "bg-vibrant-orange text-white shadow-lg shadow-vibrant-orange/20 ring-1 ring-white/20 font-semibold"
                  : "text-white/75 hover:text-white hover:bg-white/5 group"
              }`}
            >
              <span className="material-symbols-outlined text-[20px] text-white/60 group-hover:text-vibrant-orange transition-colors">
                search
              </span>
              <span className="font-label-md">  البحث العام بالجمعيات
              </span>
            </a>
            <a
              data-path="store-services"
              href="/admin/updateOrgsExll"
              onClick={() => localStorage.setItem("Tab", "updateOrgsExll")}
              className={`flex items-center px-3.5 py-2.5 rounded-lg transition-all gap-3 text-sm ${
                active === "updateOrgsExll"
                  ? "bg-vibrant-orange text-white shadow-lg shadow-vibrant-orange/20 ring-1 ring-white/20 font-semibold"
                  : "text-white/75 hover:text-white hover:bg-white/5 group"
              }`}
            >
              <span className="material-symbols-outlined text-[20px] text-white/60 group-hover:text-vibrant-orange transition-colors">
                hub
              </span>
              <span className="font-label-md">
                {" "}
                تحديث بيانات الجمعيات عبر اكسل
              </span>
            </a>
            <a
              data-path="associations"
              href="/admin/linkOrgsCategories"
              onClick={() => localStorage.setItem("Tab", "linkOrgsCategories")}
              className={`flex items-center px-3.5 py-2.5 rounded-lg transition-all gap-3 text-sm ${
                active === "linkOrgsCategories"
                  ? "bg-vibrant-orange text-white shadow-lg shadow-vibrant-orange/20 ring-1 ring-white/20 font-semibold"
                  : "text-white/75 hover:text-white hover:bg-white/5 group"
              }`}
            >
              <span className="material-symbols-outlined text-[20px] text-white/60 group-hover:text-vibrant-orange transition-colors">
                corporate_fare
              </span>
              <span className="font-label-md"> ربط الجمعيات بالخدمات</span>
            </a>
            <a
              data-path="stores"
              href="/admin/linkOrgsActivities"
              onClick={() => localStorage.setItem("Tab", "linkOrgsActivities")}
              className={`flex items-center px-3.5 py-2.5 rounded-lg transition-all gap-3 text-sm ${
                active === "linkOrgsActivities"
                  ? "bg-vibrant-orange text-white shadow-lg shadow-vibrant-orange/20 ring-1 ring-white/20 font-semibold"
                  : "text-white/75 hover:text-white hover:bg-white/5 group"
              }`}
            >
              <span className="material-symbols-outlined text-[20px] text-white/60 group-hover:text-vibrant-orange transition-colors">
                storefront
              </span>
              <span className="font-label-md">ربط الجمعيات بالنشاطات </span>
            </a>
          </div>
          {/* قسم التقارير والبيانات */}
          {/* <div className="flex flex-col gap-1">
        <div className="px-3 pb-1 text-[11px] font-semibold uppercase tracking-wider text-white/40">
          التقارير والبيانات
        </div>
        <a
          className="flex items-center px-3.5 py-2.5 rounded-lg text-white/75 hover:text-white hover:bg-white/5 transition-all gap-3 text-sm group"
          data-path="excel"
          href="#"
        >
          <span className="material-symbols-outlined text-[20px] text-white/60 group-hover:text-vibrant-orange transition-colors">
            table_view
          </span>
          <span className="font-label-md">استيراد وتصدير Excel</span>
        </a>
        <a
          className="flex items-center px-3.5 py-2.5 rounded-lg text-white/75 hover:text-white hover:bg-white/5 transition-all gap-3 text-sm group"
          data-path="activity-reports"
          href="#"
        >
          <span className="material-symbols-outlined text-[20px] text-white/60 group-hover:text-vibrant-orange transition-colors">
            analytics
          </span>
          <span className="font-label-md">تقارير النشاط</span>
        </a>
        <a
          className="flex items-center px-3.5 py-2.5 rounded-lg text-white/75 hover:text-white hover:bg-white/5 transition-all gap-3 text-sm group"
          data-path="sales-reports"
          href="#"
        >
          <span className="material-symbols-outlined text-[20px] text-white/60 group-hover:text-vibrant-orange transition-colors">
            trending_up
          </span>
          <span className="font-label-md">تقارير المبيعات</span>
        </a>
        <a
          className="flex items-center px-3.5 py-2.5 rounded-lg text-white/75 hover:text-white hover:bg-white/5 transition-all gap-3 text-sm group"
          data-path="financial-audit"
          href="#"
        >
          <span className="material-symbols-outlined text-[20px] text-white/60 group-hover:text-vibrant-orange transition-colors">
            account_balance
          </span>
          <span className="font-label-md">التدقيق المالي</span>
        </a>
      </div> */}
          {/* قسم الإعدادات */}
          <div className="flex flex-col gap-1 pb-3">
            <div className="px-3 pb-1 text-[11px] font-semibold uppercase tracking-wider text-white/40">
              الإعدادات
            </div>
            <a
              data-path="settings"
              href="/admin/categories"
              onClick={() => localStorage.setItem("Tab", "categories")}
              className={`flex items-center px-3.5 py-2.5 rounded-lg transition-all gap-3 text-sm ${
                active === "categories"
                  ? "bg-vibrant-orange text-white shadow-lg shadow-vibrant-orange/20 ring-1 ring-white/20 font-semibold"
                  : "text-white/75 hover:text-white hover:bg-white/5 group"
              }`}
            >
              <span className="material-symbols-outlined text-[20px] text-white/60 group-hover:text-vibrant-orange transition-colors">
                settings
              </span>
              <span className="font-label-md">إدارة الخدمات </span>
            </a>
            <a
              data-path="payments"
              href="/admin/activities"
              onClick={() => localStorage.setItem("Tab", "activities")}
              className={`flex items-center px-3.5 py-2.5 rounded-lg transition-all gap-3 text-sm ${
                active === "activities"
                  ? "bg-vibrant-orange text-white shadow-lg shadow-vibrant-orange/20 ring-1 ring-white/20 font-semibold"
                  : "text-white/75 hover:text-white hover:bg-white/5 group"
              }`}
            >
              <span className="material-symbols-outlined text-[20px] text-white/60 group-hover:text-vibrant-orange transition-colors">
                credit_card
              </span>
              <span className="font-label-md"> إدارة الإنشطة </span>
            </a>
             <a
              data-path="payments"
              href="/admin/listMobiles"
              onClick={() => localStorage.setItem("Tab", "listMobiles")}
              className={`flex items-center px-3.5 py-2.5 rounded-lg transition-all gap-3 text-sm ${
                active === "listMobiles"
                  ? "bg-vibrant-orange text-white shadow-lg shadow-vibrant-orange/20 ring-1 ring-white/20 font-semibold"
                  : "text-white/75 hover:text-white hover:bg-white/5 group"
              }`}
            >
              <span className="material-symbols-outlined text-[20px] text-white/60 group-hover:text-vibrant-orange transition-colors">
                credit_card
              </span>
              <span className="font-label-md"> إدارة ارقام جوالات الوصول الى الخرائط </span>
            </a>
          </div>
        </nav>
        {/* Fixed Bottom User Profile / Actions Section */}
        <div className="shrink-0 p-3 border-t border-white/10 bg-deep-navy/95 backdrop-blur-md">
          <div className="flex items-center justify-between p-2 rounded-xl bg-white/[0.04] border border-white/10">
            <div className="flex items-center gap-2.5 overflow-hidden">
              <img
                alt="User"
                className="w-9 h-9 rounded-full object-cover border border-vibrant-orange shrink-0"
                src="https://lh3.googleusercontent.com/aida/AEtjO1WYsjpy0aYCPZDNYhiIzypae7K2Gl1bp1MpxC0fVrAaF5UQpRQmhI7lsvzGeXVVeY5_I3-jgu6jXzCqMnA_xAo4LvIquRX6pRTxSzD_NBnH1s_YkCoY1ZoAFQ8OdxK0rjEYDMm-7zDMSapbWYZp-I3_yJ1BSJcL5mevuYVWt80ZFZ6DDFVL2gIAyGsl2UGhzbQ_yArmfRJKU_js0ZzzAgKO7Zu9-utV6rYkeJGBCtaqEA7QpqBDV7tn-LwlL_tcZHU0-QYvrFe-2f4"
              />
              <div className="flex flex-col min-w-0">
                <span className="text-xs font-semibold text-white truncate">
                   {localStorage.getItem("user-server")}  
                </span>
                <span className="text-[10px] text-emerald-400 flex items-center gap-1">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 inline-block" />
                  متصل الآن
                </span>
              </div>
            </div>
            <button
              className="p-1.5 text-white/60 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
              title="المساعدة والدعم"
            >
              <span className="material-symbols-outlined text-lg">
                help_outline
              </span>
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default LeftSideBare;
